import { render, staticRenderFns } from "./IntegracaoDefault.vue?vue&type=template&id=f8cf81d8&scoped=true"
import script from "./IntegracaoDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegracaoDefault.vue?vue&type=script&setup=true&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=f8cf81d8&prod&scoped=true&lang=css&external"
import style1 from "./IntegracaoDefault.vue?vue&type=style&index=1&id=f8cf81d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cf81d8",
  null
  
)

export default component.exports